<template>
  <v-app>
    <!-- Barra de navegación horizontal (superior) -->
    <v-app-bar app color="indigo" dark>
      <!-- Botón para el menú en dispositivos móviles -->
      <v-btn v-if="isMobile" icon @click="drawer = !drawer">
        <v-icon color="white">mdi-menu</v-icon>
        <!-- Icono de hamburguesa con color blanco -->
      </v-btn>

      <!-- Contenedor para el nombre de usuario -->
      <v-toolbar-title class="d-flex justify-start align-center" style="flex-grow: 1">
        <span v-if="isLoggedIn" class="mr-4">{{ username }}</span>
        <span v-else class="mr-4">Iniciar sesión</span>
      </v-toolbar-title>

      <!-- Espaciador para alinear el logo de la empresa a la derecha -->
      <v-spacer></v-spacer>

      <!-- Logotipo de la Empresa -->
      <v-img
        src="https://via.placeholder.com/100"
        alt="Logo de la Empresa"
        max-width="100"
      />
    </v-app-bar>

    <!-- Barra de navegación vertical (debajo de la barra horizontal) -->
    <v-navigation-drawer
      app
      v-model="drawer"
      :permanent="!isMobile"
      :temporary="isMobile"
      class="black-text"
      width="200"
      style="height: 100vh; z-index: 1000"
    >
      <v-list dense>
        <v-list-item @click="goToAdmin">
          <v-list-item-content>
            <v-list-item-title class="white--text">Administrar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="goToCourses">
          <v-list-item-content>
            <v-list-item-title class="white--text">Cursos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="goToTutorials">
          <v-list-item-content>
            <v-list-item-title class="white--text">Tutoriales</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="goToGrades">
          <v-list-item-content>
            <v-list-item-title class="white--text">Notas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- Contenido principal -->
    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  name: "MainPage",
  data() {
    return {
      drawer: false, // Estado de apertura/cierre del menú
      isLoggedIn: true, // Estado de login
      username: "Juan Pérez", // Nombre del usuario logueado
    };
  },
  computed: {
    // Comprobar si el dispositivo es móvil
    isMobile() {
      return window.innerWidth <= 600; // Determina si es móvil con un ancho máximo de 600px
    },
  },
  methods: {
    // Métodos de navegación
    goToAdmin() {
      this.$router.push({ name: "administrar" });
    },
    goToCourses() {
      this.$router.push({ name: "courses" });
    },
    goToTutorials() {
      this.$router.push({ name: "tutorials" });
    },
    goToGrades() {
      this.$router.push({ name: "grades" });
    },
  },
};
</script>

<style scoped>
/* Barra de navegación superior */
.v-app-bar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Barra de navegación vertical */
.v-navigation-drawer {
  background-color: black !important;
  position: fixed;
  top: 64px; /* Se asegura de estar debajo de la barra superior */
  bottom: 0;
  height: calc(100vh - 64px);
  z-index: 1000;
}

/* Estilos del texto blanco en la barra vertical */
.white--text {
  color: white !important;
}

/* Responsividad: Ajustes para pantallas pequeñas */
@media (max-width: 600px) {
  .v-navigation-drawer {
    width: 150px !important; /* Reducir el ancho de la barra lateral */
  }

  .v-app-bar {
    font-size: 14px; /* Reducir el tamaño del texto en la barra horizontal */
  }

  .v-list-item-title {
    font-size: 12px; /* Reducir el tamaño del texto del menú vertical */
  }
}

/* Pantallas grandes: No debe aparecer el menú lateral como temporal */
@media (min-width: 601px) {
  .v-navigation-drawer {
    width: 200px !important; /* Establece el ancho fijo para pantallas grandes */
    position: fixed !important; /* Fija la barra lateral para pantallas grandes */
    top: 64px; /* Asegura que esté debajo de la barra superior */
  }

  .v-main {
    margin-left: 200px; /* Desplaza el contenido principal para dejar espacio a la barra lateral */
  }
}
</style>
